import { AppRoute } from '@agentselly/immodossier-shared';
import { propertyFormWidgets } from '~/config/widgets/propertyFormWidgets';
import { makeQueryLoaderWidgetsRoute } from '~/helper/makeQueryLoaderWidgetsRoute';

export const Route = makeQueryLoaderWidgetsRoute(
  AppRoute.$LANG_$COMPANYID_$CONTACTID_DOSSIER_$DOSSIERID_PROPERTY_EDIT,
  propertyFormWidgets,
  { v3PageTitle: 'Objektdaten' },
);
